<template>
  <div class="page-ct">
    <template v-if="!loadingState">
      <div class="page-header">
        <strong>Public Products</strong>
        <button v-if="canWrite" v-on:click="addItem()">Create Product</button>
      </div>

      <p class="no_list_items" v-if="products.length < 1 && !selectedProduct">
        There are no products for the moment. Please try to
        <a v-if="canWrite" href="javascript:;" class="link" v-on:click="doImport()"
          >import from configuration file</a
        >
        or create a new one.
      </p>

      <splitpanes class="default-theme page-content" v-if="products.length > 0 || selectedProduct != null">
        <pane size="30" class="left-pane">
          <div class="list-view mr-0">
            <div
              v-for="(pr, i) in products"
              :key="i"
              v-on:click="onSelectProduct(pr)"
              v-bind:class="{
                selected: selectedProduct !== null && pr.id === selectedProduct.id,
              }"
            >
              {{ pr.content.name }}
            </div>
          </div>
        </pane>
        <pane size="70">
          <p class="page-desc" v-if="!selectedProduct">
            <span>
              Here you can manage Insight Hub app public applications. Select entry to edit details.
            </span>
          </p>
          <div class="app-detail" v-if="selectedProduct">
            <div class="header-line">
              <span>
                {{ selectedProduct.content.name }}
              </span>
              <span>
                <i
                  class="action material-icons"
                  v-on:click="removeProduct()"
                  v-if="+selectedProduct.id > 0 && canWrite"
                  >delete</i
                >
                <button v-if="canWrite" v-on:click="saveProduct()" style="margin: 0 8px;">
                  Save
                </button>
                <i class="action material-icons" v-on:click="selectedProduct = null">close</i>
              </span>
            </div>
            <!-- form -->
            <div class="app-form-editor">
              <div class="editor-line form-row dates">
                Created At: <strong>&nbsp;{{ selectedProduct.created_at | formatDate }}</strong
                >, Last Modified:
                <strong>&nbsp;{{ selectedProduct.updated_at | formatDate }}</strong>
              </div>
              <div class="editor-line form-row">
                <label>Order</label>
                <input
                  style="width: 80px;"
                  :readonly="!canWrite"
                  type="number"
                  v-model="selectedProduct.product_order"
                  id="product_order"
                />
              </div>
              <div class="editor-line form-row">
                <label>Name</label>
                <input :readonly="!canWrite" type="text" v-model="selectedProduct.content.name" id="name" />
              </div>
              <div class="editor-line form-row">
                <label>Description</label>
                <textarea
                  :readonly="!canWrite"
                  type="text"
                  v-model="selectedProduct.content.description"
                  id="desc"
                ></textarea>
              </div>
              <div class="editor-line form-row">
                <label>Image</label>
                <div class="space-between">
                  <img
                    v-if="selectedProduct.content.thumb"
                    style="height:150px"
                    :src="`/api/fs/public-products/${selectedProduct.content.thumb}`"
                  />
                  <p v-if="selectedProduct.content.thumb">
                    {{ selectedProduct.content.thumb }}
                  </p>
                  <button v-if="canWrite" @click="chooseImg()">Change Img</button>
                  <div v-if="!canWrite"></div>
                </div>
              </div>
              <div class="editor-line form-row">
                <label>Video URL</label>
                <input
                  :readonly="!canWrite"
                  type="text"
                  v-model="selectedProduct.content.videoUrl"
                  id="videoUrl"
                />
              </div>
              <div class="editor-line form-row">
                <label>Demo URL</label>
                <input
                  :readonly="!canWrite"
                  type="text"
                  v-model="selectedProduct.content.demoUrl"
                  id="demoUrl"
                />
              </div>
              <br v-if="selectedProduct.id" />
              <div class="editor-line form-row" v-if="selectedProduct.id">
                <label>Overview</label>
                <input
                  style="display: none"
                  type="file"
                  id="file_input"
                  ref="file_input"
                  accept="image/*"
                  @change="startUpload()"
                />
                <div class="space-between">
                  <img
                    v-if="selectedProduct.overview_file_name"
                    style="height:150px"
                    :src="`/api/fs/public-products/overview/${selectedProduct.overview_file_name}`"
                  />
                  <div v-else></div>
                  <div class="img-file" v-if="selectedProduct.overview_file_name" @click="openImgPreview()">
                    <i class="material-icons">image</i>
                    <span>{{ selectedProduct.overview_file_name }}</span>
                  </div>
                  <span style="margin-left:20px" v-if="!selectedProduct.overview_file_name"
                    >No Image attached</span
                  >
                  <div class="overview-actions">
                    <i
                      style="margin-right:10px"
                      v-if="canWrite && selectedProduct.overview_file_name"
                      class="action material-icons"
                      v-on:click="downloadImgPreview()"
                      >get_app</i
                    >
                    <i
                      style="margin-right:20px"
                      v-if="canWrite && selectedProduct.overview_file_name"
                      class="action material-icons"
                      v-on:click="selectedProduct.overview_file_name = null"
                      >delete_outline</i
                    >
                    <button v-if="canWrite" @click="doUploadImgFile()">Change Img</button>
                  </div>
                  <div v-if="!canWrite"></div>
                </div>
              </div>
              <br v-if="selectedProduct.id" />
              <div class="editor-line form-row">
                <label>User Groups</label>
                <div class="flex-wrap">
                  <div v-for="(gr, i) in userGroups" :key="i" class="checkbox">
                    <input :disabled="!canWrite" type="checkbox" v-model="userGroupsSelection[gr]" />
                    <label>{{ gr }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </pane>
      </splitpanes>
    </template>
    <template v-else>
      <div class="loading-spinner-ct">
        <div class="loading-spinner"></div>
        <span>{{ loadingMsg }}</span>
      </div>
    </template>
    <!-- SnackBar + Confirm Dialog -->
    <div id="snackbar">{{ snackBarText }}</div>
    <ImagePickerDialog ref="imagePickerDialog"></ImagePickerDialog>
    <ConfirmDialog ref="confirmDialogue"></ConfirmDialog>
    <PublicProductOverview ref="publicProductOverview"></PublicProductOverview>
  </div>
</template>
<script>
import HttpService from '@/services/http.service'
import ConfirmDialog from '@/components/dialogs/components/ConfirmDialog.vue'
import PublicProductOverview from '@/components/dialogs/components/PublicProductOverview.vue'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import AdminPermissionsService from '@/services/admin-permissions.service'
import ImagePickerDialog from '@/components/dialogs/components/ImagePickerDialog.vue'

export default {
  name: 'AdminPublicProducts',
  components: {
    ConfirmDialog,
    Splitpanes,
    Pane,
    ImagePickerDialog,
    PublicProductOverview,
  },
  data: function() {
    return {
      selectedProduct: null,
      snackBarText: '',
      products: [],
      loadingState: false,
      loadingMsg: '',
      userGroups: [],
      userGroupsSelection: {},
      files: [],
      assignedImages: [],
    }
  },
  computed: {
    canWrite() {
      const aps = new AdminPermissionsService()
      return aps.canWrite('public_products')
    },
  },
  mounted: async function() {
    this.loadingState = true
    this.loadingMsg = 'Loading Data'
    this.loadProducts()
  },
  methods: {
    async downloadImgPreview() {
      let link = document.createElement('a')
      link.href = `/api/fs/public-products/overview/${this.selectedProduct.overview_file_name}`
      link.download = this.selectedProduct.overview_file_name
      link.dispatchEvent(new MouseEvent('click'))
    },
    async openImgPreview() {
      await this.$refs.publicProductOverview.show({
        file_name: this.selectedProduct.overview_file_name,
        product_name: this.selectedProduct.content.name
      })
    },
    async doUploadImgFile() {
      this.$refs.file_input.click()
    },
    async startUpload() {
      try {
        const url = `/admin/public-products/upload`
        var formData = new FormData()
        var imagefile = document.querySelector('#file_input')
        formData.append('files', imagefile.files[0])
        formData.append('product_id', this.selectedProduct.id)
        this.loadingState = true
        this.loadingMsg = 'Uploading file'
        const data = await HttpService.upload(url, formData, {
          'Content-Type': 'multipart/form-data',
        })
        this.loadingState = false
        if (data) {
          if (data === 'bad_format') {
            this.openSnackbar('Bad File Format. Please upload an image file!', true, 5000)
          } else {
            this.openSnackbar(data.msg)
            if (data.data) {
              this.selectedProduct.overview_file_name = data.data.overview_file_name
            }
          }
        }
      } catch (err) {
        alert(err)
      } finally {
        await this.loadProducts()
      }
    },
    openSnackbar(text) {
      setTimeout(() => {
        this.snackBarText = text
        let x = document.getElementById('snackbar')
        x.className = 'open'
        setTimeout(() => {
          x.className = x.className.replace('open', '')
        }, 3000)
      }, 300)
    },
    async removeProduct() {
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Delete Product',
        message: 'Are you sure you want to delete this product?',
        okButton: 'Yes',
      })
      if (ok) {
        this.loadingState = true
        this.loadingMsg = 'Removing Product and reloading'
        const url = `/admin/public-products`
        await HttpService.delete(url + '/' + this.selectedProduct.id)
        await this.loadProducts()
        this.loadingState = false
        this.openSnackbar('Product deleted!')
        this.selectedProduct = null
      }
    },
    onSelectProduct(product) {
      this.selectedProduct = product
      this.userGroupsSelection = {}
      if (this.selectedProduct.content.userGroups && this.selectedProduct.content.userGroups.length > 0) {
        this.selectedProduct.content.userGroups.map((el) => {
          if(this.userGroups.indexOf(el) >= 0){
            this.userGroupsSelection[el] = true
          }
        })
      }
    },
    async saveProduct() {
      let newUserGroups = []
      Object.keys(this.userGroupsSelection).map((key) => {
        if (this.userGroupsSelection[key] === true) {
          newUserGroups.push(key)
        }
      })
      this.selectedProduct.content.userGroups = newUserGroups
      console.log(this.selectedProduct.content.userGroups, this.userGroupsSelection)
      this.loadingState = true
      this.loadingMsg = 'Saving Product into database'
      const url = `/admin/public-products`
      await HttpService.post(url, this.selectedProduct)
      this.loadingState = false
      this.openSnackbar('Product saved!')
      this.loadProducts()
    },
    async doImport() {
      this.loadingState = true
      this.loadingMsg = 'Importing Product from config files'
      const url = `/admin/public-products/import`
      await HttpService.get(url)
      this.loadingState = false
      this.openSnackbar('Products imported!')
      this.loadProducts()
    },
    async loadProducts() {
      const url = `/admin/public-products`
      const res = await HttpService.get(url)
      this.products = res.data
      this.assignedImages = []
      res.data.map((el) => {
        if (el.content && el.content.thumb) {
          this.assignedImages.push(el.content.thumb)
        }
      })
      this.userGroups = res.userGroups
      this.files = res.files
      this.loadingState = false
    },
    async chooseImg() {
      const res = await this.$refs.imagePickerDialog.show({
        title: 'Select Product Image',
        images: this.files,
        selectedImage: this.selectedProduct.content.thumb,
        category: 'public-products',
        assigned_images: this.assignedImages,
      })
      if (res) {
        let newVal = res
        if (res === 'clear') {
          newVal = null
        }
        this.selectedProduct.content.thumb = newVal
      }
    },
    addItem() {
      this.userGroupsSelection = {}
      this.selectedProduct = {
        product_order: this.products.length + 1,
        content: {
          thumb: '',
        },
      }
    },
  },
}
</script>
<style scoped src="../../../../assets/css/admin-section.css"></style>
<style scoped>
.overview-actions {
  margin-right: 0 !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.img-file {
  display: flex;
  margin-left: 20px;
  color: #282f54;
}
.img-file i {
  margin-right: 5px;
}
.img-file span:hover {
  text-decoration: underline;
  cursor: pointer;
  color: #0a4bb7;
}
.flex-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.list-view {
  width: 100%;
  height: 100%;
}
.space-between {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
</style>
